<template>
  <Campaign
    v-if="campaignData && campaignData.config"
    :key="campaignData.config.campaign_id"
    :data="campaignData"
    :is-demo="false"
  />
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, nextTick, ref } from 'vue';
import Campaign from '@/src/components/Campaign.vue';
import type { CampaignData } from '@/src/typings/interfaces/data/campaign';
import { recursivelyWaitForPromises } from '@/src/utilities/virtualDom';
import { useUtilityStore } from '@/src/store/utility';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'CampaignIframeQueueView',
  components: {
    Campaign
  },
  setup() {
    const utilityStore = useUtilityStore();
    const route = useRoute();

    utilityStore.overwrittenUrl = typeof window !== 'undefined' ? window.location.href : route.fullPath;

    const campaignData = ref<CampaignData | undefined>(
      window.PLAYABLE_CAMPAIGN !== undefined && window.PLAYABLE_CAMPAIGN !== '#pl_data#'
        ? JSON.parse(window.atob(window.PLAYABLE_CAMPAIGN))
        : undefined
    );

    let readyPromiseResolve: (() => void) | undefined;

    const readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });

    const currentInstance = getCurrentInstance();

    nextTick(async () => {
      if (currentInstance?.vnode) {
        await recursivelyWaitForPromises(currentInstance.vnode, 'onBeforeEnter', 3);
      }

      if (readyPromiseResolve) {
        readyPromiseResolve();
      }
    });

    return {
      campaignData,
      readyPromise
    };
  }
});
</script>
